export default __webpack_public_path__ + "static/media/WM0480.34I-43543_-26177_0.6042e1b1.jpg";